import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import startpageAnimation from "./assets/startpageAnimation.json";

import HomePage from "./components/HomePage";
import NavBar from "./components/NavBar";
import Lottie from "lottie-react";
import DynamicScreen from "./components/DynamicScreen";
import Features from "./components/Features";
import TeamSection from "./components/TeamSection";
import DestinationsSection from "./components/DestinationsSection";
import TextApp from "./components/TextApp";
import Footer from "./components/Footer";
import TermsService from "./components/TermsService"; // Import TermsService
import chat from "./assets/featureIcons/chat.png";
import connect from "./assets/featureIcons/connect.png";
import heart from "./assets/featureIcons/heart.png";
import memory from "./assets/featureIcons/memory.png";
import trustworthy from "./assets/featureIcons/trustworthy.png";
import RotatedImageSection from "./components/RotatedImageSection";
import PreRegisterModal from "./components/PreRegisterModal";
import appStore from "./assets/appStore.png";
import playStore from "./assets/playStore.png";

function App() {
  const features = [
    {
      name: "Activity-Based Connections",
      description:
        " Find and connect with people based on shared interests like hangouts, sports, or special events.",
      icon: connect,
    },
    {
      name: "Build Real Friendships",
      description:
        " Follow and engage with others to create lasting friendships and meaningful bonds.",
      icon: heart,
    },
    {
      name: "Seamless Communication",
      description:
        " Chat with your connections and deepen relationships through engaging conversations.",
      icon: chat,
    },
    {
      name: "Memory Sharing",
      description:
        " Share special moments and memories with your friends, keeping connections strong.",
      icon: memory,
    },
    {
      name: "Show You Care",
      description:
        " Celebrate milestones, show appreciation, and be there for the important moments in your friends lives.",
      icon: trustworthy,
    },
  ];

  const [selectedFeature, setSelectedFeature] = useState(features[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const leftFeatures = features.slice(0, 2);
  const rightFeatures = features.slice(2, 4);

  return (
    <Router>
      <Routes>
        {/* Home Page Route */}
        <Route
          path="/"
          element={
            <div className="overflow-x-hidden">
              <NavBar />
              <div className="flex flex-col mt-36 items-center justify-center sm:mt-10">
                <div className="w-2/3 sm:w-1/3 lg:w-1/5 flex justify-center items-center p-2">
                  <Lottie
                    animationData={startpageAnimation}
                    className="w-full h-full"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  />
                </div>
                <HomePage />
              </div>
              <div className="w-full h-1/3">
                <div className="flex flex-col md:flex-row justify-center items-center mt-20 lg:mb-10">
                  <div className="order-1 lg:order-2 w-full md:w-1/3 p-6 md:p-10">
      <DynamicScreen
        feature={features.find((f) => f.name === selectedFeature.name)}
        className="text-base sm:text-lg md:text-xl lg:text-2xl"
      />
                  </div>

    {/* Left Features (First Two) */}
                  <div className="order-2 lg:order-1 w-full md:w-1/4 p-6 md:p-10">
      <Features
        features={leftFeatures}
        className="text-base sm:text-lg md:text-xl lg:text-2xl"
      />
                  </div>

    {/* Right Features (Last Two) */}
                  <div className="order-3 w-full md:w-1/4 p-6 md:p-10">
      <Features
        features={rightFeatures}
        className="text-base sm:text-lg md:text-xl lg:text-2xl"
      />
                  </div>
                </div>

                <div className="flex justify-center space-x-4 pb-10">
    <img
      src={appStore}
      alt="App Store"
      className="w-38 h-12 align-middle inline-block"
    />
    <img
      src={playStore}
      alt="Play Store"
      className="w-38 h-12 align-middle inline-block"
    />
                </div>
              </div>

      <div className="flex justify-center items-center  mb-10 md:mb-20 lg:mb-20">
              <TeamSection />
      </div>
      <div></div>
      <div className="flex justify-center items-center h-[400px] md:h-[500px] lg:h-[500px]">
              <RotatedImageSection />
      </div>
              <DestinationsSection />
              <TextApp handleOpenModal={handleOpenModal} />
      {isModalOpen && <PreRegisterModal onClose={handleCloseModal} />}{" "}
      {/* Render modal conditionally */}
              <Footer />
            </div>
          }
        />

        {/* Terms of Service Route */}
        <Route path="/terms-service" element={<TermsService />} />
      </Routes>
    </Router>
  );
}

export default App;
